import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from '../../../models/project';

@Component({
  selector: 'tr[cw-project-list-item]',
  templateUrl: './project-list-item.component.html',
  styleUrls: ['./project-list-item.component.scss']
})
export class ProjectListItemComponent implements OnInit {
  @Input() project: Project;
  @Input() checked: boolean;
  @Output() toggled: EventEmitter<boolean> = new EventEmitter<boolean>();
  //@HostBinding('class') className: string = 'cw-table-row';

  constructor() {
  }

  onToggle(e: any) {
    e.preventDefault();
    e.stopPropagation();
    this.toggled.emit(!this.checked);
    return false;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/projects/list/project-list-item/project-list-item.component.ts